import Navbar from '@/components/Navbar'
import Hero from '@/components/Hero'
import Section from '@/components/Section'
import PricingEstimator from '@/components/PricingEstimator'
import AspectRatioSolver from '@/components/AspectRatioSolver'
import VansFormula from '@/components/VansFormula'
import StyleGallery from '@/components/StyleGallery'
import GuidesBlocks from '@/components/GuidesBlocks'
import Footer from '@/components/Footer'

function Home() {
  return (
    <div id="top" className="min-h-screen bg-[#070a13]">
      <Navbar />
      <main>
        <Hero />

        <Section
          id="pricing"
          eyebrow="Logo Pricing Calculator"
          title="Interactive Logo Quote & Pricing Estimator"
          description="Build an itemized branding estimate with our agency fee-calculating matrix. Tune expertise tier, labor hours, revisions, market index, and licensing rights for an instant quote."
        >
          <PricingEstimator />
        </Section>

        <Section
          id="aspect"
          eyebrow="Logo Calculator"
          title="Safe Margin & Aspect Ratio Solver"
          description="Verify whether your dimensions match the Golden Ratio, a perfect square, or cinematic 16:9 — then visualize safe padding live inside a resizable logo wrapper."
        >
          <AspectRatioSolver />
        </Section>

        <Section
          id="vans"
          eyebrow="Vans Logo Calculator"
          title="Skateboard Formula Canvas"
          description="The classic Off The Wall in-joke: any word nestled inside a square-root symbol. Type below and watch the radical bar stretch to fit — the answer is always you."
        >
          <VansFormula />
        </Section>

        <Section
          id="galleries"
          eyebrow="Style Galleries"
          title="Black, White & Neon Calculator Logos"
          description="Visual style guides exploring how a single calculator mark adapts across monochrome, reversed, and glowing neon treatments."
        >
          <StyleGallery />
        </Section>

        <Section
          id="guides"
          eyebrow="Logo of / for Calculator"
          title="Design History & SEO Copy Toolkit"
          description="Educational deep-dives plus one-click marketing templates: meta descriptions, H1 concepts, and content briefs ready to ship."
        >
          <GuidesBlocks />
        </Section>
      </main>
      <Footer />
    </div>
  )
}

export default Home
